import { RADIUS, SHADOW, SPACE, T, type Space, type Token } from '@/design/tokens';
import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';

interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  children: ReactNode;
  accent?: Token;
  padding?: Space;
  variant?: 'base' | 'alt';
}

export function Card({
  children,
  accent,
  padding = 'md',
  variant = 'base',
  style,
  ...rest
}: CardProps) {
  const baseStyle: CSSProperties = {
    background: variant === 'alt' ? T.cardAlt : T.card,
    border: `1px solid ${T.border}`,
    borderLeft: accent ? `3px solid ${T[accent]}` : `1px solid ${T.border}`,
    borderRadius: RADIUS.md,
    padding: SPACE[padding],
    boxShadow: SHADOW.card,
    color: T.text,
  };

  return (
    <div {...rest} style={{ ...baseStyle, ...style }}>
      {children}
    </div>
  );
}
